import { getCurrentInstance } from "vue";
import { u as useAppGlobal } from "./useAppGlobal.js";
const useComponentUuid = () => {
  const vm = getCurrentInstance();
  const counter = useAppGlobal("uuidCounter", 0);
  vm.$vaUuid = vm.$vaUuid || `va-${counter.value++}`;
  return `va-${counter.value}`;
};
export {
  useComponentUuid as u
};
//# sourceMappingURL=useComponentUuid.js.map
